export default class SigninCtrl {
  constructor($location, $scope, ReloadServ, CurrentUser, $window, $timeout,
    $routeParams) {
    this.user = CurrentUser;
    this.routeParams = $routeParams;
    this.reloadServ = ReloadServ
    this.timeout = $timeout;
    this.window = $window;
    this.location = $location;
    this.scope = $scope;

    this.timeout(() => {
      document.querySelectorAll('[name="email"]')[0].focus()
    })

    // this.user.api.get().then(user => {
    //   $location.path('/home');
    // });
    this.resetSignup();
  }

  resetSignup() {
    this.user.data = {
      rememberMe: true
    };
    this.sms = {
      busy: false,
      done: false
    };
    this.signUpConfirm = false;
  };


  showCodeEntry() {
    this.codeEntryVisible = true;
    this.timeout(() => {
      document.querySelectorAll('[name="mfaCode"]')[0].focus()
    })

  };

  submit(modal) {
    // delete this.statusMessages.mfaCode;

    this.user.api.signin().then((data) => {
      this.reloadServ.updateTabs();
      // Set location destination and force a page reload to ensure latest
      // Visit /mobile page if browser is mobile (passing path to redirect if user continues). 

      // redirect user to requested path or home on login
      if (modal) {
        this.scope.$close(data);
      } else {
        var redirectPath;
        if (this.routeParams.redirect) {
          redirectPath = this.routeParams.redirect;
        } else {
          redirectPath = this.window.isFactWindow ?
            '/fact' : '/home';
          if (this.user.data.lastCaseId) {
            redirectPath += `/${this.user.data.lastCaseId}`;
          }
        }

        this.window.location.href = '/app/#' + this.location.url(
          redirectPath).url();
        this.window.location.reload();
      }

    }, () => {
      if (this.user.error.data && (this.user.error.data.mfaCode || this.user
          .error.details === 'Token is invalid.')) {
        this.showCodeEntry();
      } else {
        // on a failed login attempt, assume a bad password and clear out
        // this field to allow the user to try again.
        this.user.data.password = '';
      }
    });
  };

  sendSMS(force) {
    if (this.sms.busy) return;
    this.sms.busy = true;
    this.user.api.sendSMS({
      email: this.user.data.email,
      force: !!force
    }).then(() => {
      this.sms.done = true;
      this.sms.busy = false;
      this.sms.feedback = {
        type: 'success',
        message: 'Please enter Auth Code sent via SMS',
      };
      this.showCodeEntry();
    }, (response) => {
      this.sms.busy = false;
      if (response.status === 400) {
        this.sms.feedback = {
          type: 'error',
          message: 'Please enter email',
        };
      } else if (response.status === 404) {
        this.sms.feedback = {
          type: 'info',
          message: 'No authentication device found.'
        };
      }
    });
  };
}
SigninCtrl.$inject = ['$location', '$scope', 'ReloadServ', 'CurrentUser',
  '$window', '$timeout', '$routeParams'
];



// WEBPACK FOOTER //
// ./project/pages/signin/signin.controller.js